import React, { useState } from 'react';

const IPCheckList = (props) => {

    const [val, setVal] = useState(props.obj.value);
    const click = (value, checked) => {
        let vals = val;


        if (checked) {
            vals.push(value);

        }
        else {
            vals = vals.filter(x => x != value);
        }



        setVal([...vals]);
        console.log("values", val);
        props.setValue(props.obj.id, vals)
    }

    return (
        <div className="form-group col-md-12">
            <label>{props.obj.label}</label>

            {
                props.obj.items.map(i =>
                    <div className="form-check" key={'d' + i.value}>
                        <input type="checkbox" className="form-check-input" checked={val.filter(x => x == i.value).length > 0} onChange={(e) => click(i.value, e.target.checked)} key={'c' + i.value} disabled={props.readonly} />
                        <label className="form-check-label" key={'l' + i.value}>{i.text}</label><br />
                    </div>
                )
            }

        </div>

    );
}


export default IPCheckList;